import React, { useMemo, useState } from 'react';
import { Modal, Button, Justify, Table, Bubble } from 'tea-component';
import './index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { openWindowUrl } from '@op/utils/url';
import ChannelLabel, { ChannelIconType } from '../ChannelLabel';
import RatingStar from '../RatingStar';
import { connect, useIntl } from 'umi';
import { getFeedsContentText } from '../../utils/languageValue';
import useReviewReplyData from './useReviewReplyData';
import { tweetsRenderList } from './constants';
import KeywordAccount from '../KeywordAccount';
import UpdateSentimentInfoBox from '../SentimentEditBox';
import { useGetSingePageSourceRule } from '@op/hooks/useGetPageSourceRule';
import CardSentiment from '@op/pages/accounts/widgets/AccountsCard/Sentiment';
import TopicBox from '../TopicBox';
import TranslateSelect from '../SelectComponents/TranslateSelect';
import { languageSelectOptions } from '@op/components/FilterBoxCommon/constant';
import useLanguage from '@op/hooks/useLanguage';
const { sortable, scrollable, autotip } = Table.addons;

export default function ReviewsModal({
  topics,
  visible,
  close,
  data,
  content: contentProps,
  language: defaultLanguage,
  gameInfo,
  topicList,
  oneLevelTopic,
}: any) {
  const { formatMessage, formatOptionsMessage } = useLanguage();
  const [language, setLanguage] = useState(defaultLanguage || 'origin');
  const content = contentProps || getFeedsContentText(data, language);
  const disable = !data?.content_url;
  return (
    <Modal
      size={800}
      visible={visible}
      caption={
        <div className='dbo-modal-header'>
          {formatMessage({ id: 'Reviews' })}
          <div className='dbo-modal-header-subtitle'>
            <TranslateSelect
              langOptions={formatOptionsMessage(languageSelectOptions)}
              lang={language}
              isSingle={true}
              getChange={(e: any) => {
                setLanguage(e);
              }}
              defaultValueText={formatMessage({ id: 'Language' })}
              originalText={'Original Language'}
              isMatchButtonWidth = {false}
              // hideIcon
              hideIconCommon
            />
          </div>
        </div>
      }
      className="dbo-reviews-modal"
      onClose={close}
    >
      <Modal.Body>
        <Case1
          content={content}
          data={data}
          language={language}
          gameInfo={gameInfo}
          topicList={topicList}
          topics={topics}
          oneLevelTopic={oneLevelTopic}
        />
      </Modal.Body>
      <Modal.Footer>
        <Bubble
          closeOnScroll
          content={
            disable
              ? formatMessage({ id: "This review don't have URL" })
              : undefined
          }
        >
          <Button
            type="primary"
            disabled={disable}
            onClick={() => openWindowUrl(data.content_url)}
          >
            {formatMessage({ id: disable ? 'No URL' : 'Go to' })}
          </Button>
        </Bubble>

        <Button type="weak" onClick={close}>
          {formatMessage({ id: 'Close' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

const Case1 = ({
  content,
  data,
  language,
  gameInfo,
  topicList,
  topics,
  oneLevelTopic,
}: any) => {
  data = data || {};
  const { formatMessage } = useIntl();
  const HeaderElement = useMemo(() => {
    let { channel_name, comment_score, is_recommend, monitor_source } = data;
    let HeardElementMap: { [key: string]: any } = {
      'google play': MobileHeader,
      'app store': MobileHeader,
      taptap: MobileHeader,
      steam: SteamHeaderCase,
      metacritic: MetacriticHeader,
    };
    const Component = HeardElementMap[channel_name];

    if (Component) {
      return (
        <Component
          channelName={channel_name}
          monitor_source={monitor_source}
          score={Number(comment_score || '0')}
          is_recommend={is_recommend || 0}
        />
      );
    }

    return null;
  }, [data]);

  return (
    <div className="reviews-body-one">
      <div className="title-box-context">
        {HeaderElement}
        <div className="title-flex">
          <UpdateSentimentInfoBox data={data}></UpdateSentimentInfoBox>

          <span className="title-flex-text">{data.reviewer}</span>
          <span className="title-flex-desc">{data.comment_time}</span>
        </div>
        <div className="title-context">{content}</div>
      </div>
      <div style={{ paddingLeft: 20 }}>
        <TopicBox
          topics={topics}
          noEdit
          data={data}
          showAll
          oneLevelTopic={oneLevelTopic}
          topicList={topicList}
        ></TopicBox>
      </div>
      {HeaderElement === null ? (
        <>
          <Justify
            className="case-data-flex"
            left={
              <div className="case-data-flex-left">
                <ChannelLabel channel_name={data.channel_name}></ChannelLabel>
                <KeywordAccount
                  className="keyword-account-info"
                  monitor_source={data.monitor_source}
                ></KeywordAccount>
              </div>
            }
            right={
              <div className="case-data-flex-right">
                {tweetsRenderList.map(({ key, text }) => {
                  const value = data[key] >= 0 ? data[key] : 0;
                  return (
                    <div className="case-right-item" key={key}>
                      <span className="item-strong">{value} </span>
                      {formatMessage({ id: text })}
                    </div>
                  );
                })}
              </div>
            }
          />
          {data.tweets_reply > 0 && (
            <TableContext
              itemData={data}
              language={language}
              gameInfo={gameInfo}
            />
          )}
        </>
      ) : null}
    </div>
  );
};

// 头部1
const MobileHeader = ({
  channelName,
  score,
}: {
  channelName: ChannelIconType;
  score: number;
}) => {
  return (
    <div className="header-case-one">
      <ChannelLabel channel_name={channelName}></ChannelLabel>
      <div className="header-flex">
        <RatingStar notext score={score}></RatingStar>
      </div>
      <div className="header-num">{score?.toFixed(1)}</div>
    </div>
  );
};
// 头部2
const SteamHeaderCase = ({ is_recommend }: { is_recommend: number }) => {
  const iconMap: any = {
    0: 'bad-icon',
    1: 'good-icon',
    Recommended: 'bad-icon',
    'Not Recommended': 'bad-icon',
  };
  return (
    <div className="header-case-two">
      <ChannelLabel channel_name={'steam'} showText={false}></ChannelLabel>
      <div className="header-title">Steam</div>
      <SvgIcon type={iconMap[is_recommend]} className="header-action" />
    </div>
  );
};
// 头部3
const MetacriticHeader = ({
  score,
  monitor_source,
}: {
  score: number;
  monitor_source: string;
}) => {
  return (
    <div className="header-case-three">
      <ChannelLabel channel_name={'metacritic'} showText={false}></ChannelLabel>
      <div className="header-title">
        Metacritic
        <span className="header-span">
          {monitor_source === 'user_review' ? 'Userscore' : 'Metascore'}:{' '}
          {score}
        </span>
      </div>
    </div>
  );
};

// 表格
const TableContext = connect((state: any, ownProps: any) => {
  const { home, opinionCommon } = state;

  return {
    userInfo: home.userInfo,
    gameInfo: ownProps?.gameInfo ? ownProps?.gameInfo : opinionCommon.gameInfo,
  };
})(({ itemData, gameInfo, userInfo, language }: any) => {
  const { Sentiment_Update } = useGetSingePageSourceRule({
    keys: 'Sentiment_Update',
  });

  const {
    pageInfoAddons,
    noData,
    tableCommon,
    sentimentInfo,
    loading,
    setSort,
    sort,
    formatMessage,
    tableList,
  } = useReviewReplyData({
    itemData,
    gameInfo,
    userInfo,
    language,
    showSentiment: !Sentiment_Update,
  });

  return (
    <>
      <div className="title-box-line" />
      <div className="title-box-table">
        {!Sentiment_Update && tableList?.length !== 0 && (
          // <div className="box-table-felx">
          //   <span className="box-table-felx-title">
          //     {formatMessage({ id: 'Sentiment' })}
          //   </span>
          //   {sentimentRenderList.map(({ key, icon }) => (
          //     <div key={key} className="box-table-felx-share">
          //       {/* <Bubble dark content="Click to deselect negative reviews"> */}
          //       <SvgIcon type={icon} className="box-table-felx-icon" />
          //       {/* </Bubble> */}
          //       {noData ? 0 : sentimentInfo[key]}%
          //     </div>
          //   ))}
          // </div>
          <CardSentiment
            sentimentsData={sentimentInfo}
            className="dbo-keywordbox-sentimentbox-border"
          />
        )}
        <Table
          records={tableList}
          className="dbo-reviews-modal-table"
          recordKey={(record: any) => record?.comment_uin}
          columns={tableCommon}
          addons={[
            ...pageInfoAddons,
            sortable({
              columns: [
                {
                  key: 'comment_time',
                  prefer: 'desc',
                },
              ],
              value: [sort],
              onChange: (value) => {
                setSort(
                  value?.[0] || {
                    by: 'comment_time',
                    order: 'desc',
                  },
                );
              },
            }),
            scrollable({
              maxHeight: 300,
            }),
            autotip({
              isLoading: loading,
              emptyText: formatMessage({
                id: 'Comments on this post have not yet been crawled.',
              }),
              loadingText: '',
            }),
          ]}
        />
      </div>
    </>
  );
});
